import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { LoginComponent } from "./auth/login/login.component";
import { SSOCallbackComponent } from "./auth/sso-callback/sso-callback.component";
import { ErrorFallbackComponent } from "./auth/error-fallback/error-fallback.component";
import { EmailConfirmationComponent } from "./onboarding/email-confirmation/email-confirmation.component";
import { OnboardingComponent } from "./onboarding/onboarding/onboarding.component";
import { SuccessComponent } from "./onboarding/success/success.component";

const routes: Routes = [
  { path: '*', redirectTo: '/app/dashboard', pathMatch: 'full' },
  { path: 'app', redirectTo: '/app/dashboard', pathMatch: 'full' },
  { path: 'app/contract-type', redirectTo: '/app/contract-type/list', pathMatch: 'full' },
  { path: 'app/clause', redirectTo: '/app/clause/list', pathMatch: 'full' },
  { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
  { path: 'app/contract', redirectTo: '/app/contract/list', pathMatch: 'full' },
  { path: 'app/user', redirectTo: '/app/user/list', pathMatch: 'full' },
  { path: 'app/role', redirectTo: '/app/role/list', pathMatch: 'full' },
  { path: 'app/notification', redirectTo: '/app/notification/list', pathMatch: 'full' },
  { path: 'app/attributes', redirectTo: '/app/attributes/list', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'sso-callback', component: SSOCallbackComponent },
  { path: 'error', component: ErrorFallbackComponent },
  { path: 'app/organisation',  redirectTo: '/app/organisation/list', pathMatch: 'full' },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'app/onboarding', component: OnboardingComponent },
  { path: 'app/onboardingsuccess', component: SuccessComponent },
  { path: 'app/verify-email', component: EmailConfirmationComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
